import React from 'react';

import {exportAuditLogs} from 'audit/AuditActions';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Dropdown from 'ui-library/dropdowns/Dropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth, OptionData} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

export interface SavedSearchModalOptionsProps {
  savedSearchOptionData: Array<OptionData>;
}

export default function SavedSearchModalOptions(props: SavedSearchModalOptionsProps): JSX.Element {
  return (
    <Dropdown
      menu={
        <Menu height={MenuHeight.MEDIUM} width={MenuWidth.SMALL}>
          <Option
            key="export audit logs"
            onSelect={() => {
              exportAuditLogs(props.savedSearchOptionData.map((optionData) => optionData.value.id));
            }}
            value="Export Audit Logs"
          >
            Export Audit Logs
          </Option>
        </Menu>
      }
    >
      <Button
        size={ButtonSize.SMALL}
        icon="options"
        buttonStyle={ButtonStyle.TERTIARY_GRAY}
        dataTestAttrs={{component: 'SavedSearchModalOptions', element: 'optionsButton'}}
      />
    </Dropdown>
  );
}
